import { render, staticRenderFns } from "./SettingsCover.vue?vue&type=template&id=601c81b2&"
import script from "./SettingsCover.vue?vue&type=script&lang=js&"
export * from "./SettingsCover.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports